import { lazy } from 'react';
/** Открывает список исполнителей */
export const ExecutorsPageAsync = lazy(() => import('./Executors/ExecutorsPage'));